function parseBoolean(value, fallback = false)
{
   if (value === '' || value === 'true' || value === true) return true;
   if (value === 'false' || value === false || value == null) return false;
   return fallback;
}

function buildOptions(element)
{
   return {
      arrows: parseBoolean(element.dataset.showArrows, true),
      autoplay: parseBoolean(element.dataset.autoplay, false),

      pagination: parseBoolean(element.dataset.showDots, true),
      gap: '10px',
      perMove: 1,
      perPage: 3,
      rewind: false,
      speed: 650,
      type: 'slide',
      autoHeight: parseBoolean(element.dataset.adaptiveHeight, false),
      breakpoints: {
         989: {
            gap: '20px',
            perPage: 2,
         },
         749: {
            arrows: false,
            gap: '16px',
            perPage: 1,
         },
      },
   };
}

function mountProductCarousel(element)
{
   const Splide = window.Splide;

   if (!Splide || element.dataset.splideMounted === 'true') return;

   const slideCount = Number.parseInt(element.dataset.slideCount || '0', 10);
   const options = buildOptions(element);

   if (slideCount <= options.perPage)
   {
      options.arrows = false;
      options.pagination = false;
      options.drag = false;
   }

   element.dataset.splideMounted = 'true';
   const splide = new Splide(element, options);
   splide.mount();
   element.splide = splide;
}

function mountAllProductCarousels()
{
   document.querySelectorAll('.product-carousel.splide, .collection-carousel.splide').forEach(mountProductCarousel);
}

function waitForSplide()
{
   if (window.Splide)
   {
      mountAllProductCarousels();
      return;
   }

   window.setTimeout(waitForSplide, 50);
}

if (document.readyState === 'loading')
{
   document.addEventListener('DOMContentLoaded', waitForSplide, { once: true });
} else
{
   waitForSplide();
}

document.addEventListener('shopify:section:load', mountAllProductCarousels);
document.addEventListener('shopify:block:select', mountAllProductCarousels);
